import { render, staticRenderFns } from "./Identificacao.vue?vue&type=template&id=007212d6"
import script from "./Identificacao.vue?vue&type=script&lang=js"
export * from "./Identificacao.vue?vue&type=script&lang=js"
import style0 from "./Identificacao.vue?vue&type=style&index=0&id=007212d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports